module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('v-card', [_c('v-layout', {
    staticClass: "fill-height",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#tab-login"
    }
  }, [_vm._v("Sign in")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#tab-register"
    }
  }, [_vm._v("Register")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "fill-height",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: 1,
    attrs: {
      "id": "tab-login"
    }
  }, [_c('form-login', {
    staticClass: "pa-3"
  })], 1), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    attrs: {
      "id": "tab-register"
    }
  }, [_c('form-register', {
    staticClass: "pa-3"
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71a5f05a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DialogAuth.vue
// module id = 382
// module chunks = 0